import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "resort-info" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--info",
  viewBox: "0 0 200 200",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-info" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "resort-info__box"
}
const _hoisted_5 = { class: "resort-info__button-close" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--close button__icon",
  viewBox: "0 0 200 200",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-close" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "button__text" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "resort-info__text" }

import { ref } from 'vue';
import { customLog } from '../../../../javascripts/utils/log';


export default {
  __name: 'resort-info',
  props: {
  showInfoText: {
    type: Boolean,
    required: false,
    default: false
  },
  resortInfoText: {
    type: String,
    required: true,
    validator: (resortInfoText) => resortInfoText.length > 0,
  }
},
  emits: {
  resortInfoOpened: () => {
    customLog('[ResortInfo]: resortInfoOpened event emitted');
    return true;
  },
  resortInfoClosed: () => {
    customLog('[ResortInfo]: resortInfoClosed event emitted');
    return true;
  }
},
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showInfoText = ref(props.showInfoText);

// Touch handling
let isMoving = ref(false);
let startX = ref(0);
let startY = ref(0);

function handleTouchStart(event) {
  startX.value = event.touches[0].clientX;
  startY.value = event.touches[0].clientY;
  isMoving.value = false;
}

function handleTouchMove() {
  isMoving.value = true;
}

function handleTouchEnd() {
  if (!isMoving.value) {
    toggleResortTooltip();
  }
}

function toggleResortTooltip() {
  customLog('[ResortInfo]: toggle resort info tooltip')
  if (showInfoText.value) {
    emit('resortInfoClosed');
  } else {
    emit('resortInfoOpened');
  }

  showInfoText.value = !showInfoText.value;
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "resort-info__icon",
        onClick: _withModifiers(toggleResortTooltip, ["stop"]),
        onTouchstart: handleTouchStart,
        onTouchmove: handleTouchMove,
        onTouchend: handleTouchEnd
      }, _hoisted_3, 32),
      _createVNode(_Transition, { name: "tooltip-fade" }, {
        default: _withCtx(() => [
          (showInfoText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(toggleResortTooltip, ["stop","prevent"]),
                    onTouchstart: handleTouchStart,
                    onTouchmove: handleTouchMove,
                    onTouchend: handleTouchEnd,
                    class: "button button--icon-only",
                    href: "#",
                    id: "resort-info__button-close"
                  }, _hoisted_8, 32)
                ]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(props.resortInfoText), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (showInfoText.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _withModifiers(toggleResortTooltip, ["stop"]),
          onTouchstart: handleTouchStart,
          onTouchmove: handleTouchMove,
          onTouchend: handleTouchEnd,
          class: "resort-info__overlay"
        }, null, 32))
      : _createCommentVNode("", true)
  ], 64))
}
}

}